var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import { Button, Dropdown } from '@leapfinance/geebee-component-library';
import FileUploadOutlined from '@mui/icons-material/FileUploadOutlined';
import { ACCEPTABLE_FILE_UPLOAD_TYPES } from '../constants/common';
import LoadingButton from './mui/LoadingButton';
var CustomDocumentUpload = function (_a) {
    var isUploading = _a.isUploading, _b = _a.dropdownClassName, dropdownClassName = _b === void 0 ? 'lfc-min-w-[250px] lfc-max-w-[500px] lfc-mr-2' : _b, _c = _a.containerClassName, containerClassName = _c === void 0 ? 'lfc-flex lfc-items-center lfc-h-10 lfc-ml-2' : _c, _d = _a.maxFileSizeAllowedInMB, maxFileSizeAllowedInMB = _d === void 0 ? 35 : _d, _e = _a.documentOptions, documentOptions = _e === void 0 ? [] : _e, _f = _a.uploadButtonText, uploadButtonText = _f === void 0 ? 'Upload Document' : _f, uploadButtonVariant = _a.uploadButtonVariant, onFileSizeUploadWarning = _a.onFileSizeUploadWarning, onFileNameRequiredWarning = _a.onFileNameRequiredWarning, handleUpload = _a.handleUpload, dropdownProps = _a.dropdownProps;
    var fileUploadRef = useRef(null);
    var _g = __read(useState(null), 2), fileName = _g[0], setFileName = _g[1];
    var _h = __read(useState(documentOptions), 2), documentOptionsLocal = _h[0], setDocumentOptionsLocal = _h[1];
    useEffect(function () {
        setDocumentOptionsLocal(documentOptions);
    }, [documentOptions]);
    // const customSort = (a: any, b: any, rawInput: string): any => {
    //   const inputValue = rawInput.trim().toLowerCase();
    //   const labelA = a.label.toLowerCase();
    //   const labelB = b.label.toLowerCase();
    //   if (labelA.startsWith(inputValue) && labelB.startsWith(inputValue)) {
    //     return labelA.localeCompare(labelB);
    //   }
    //   if (labelA.startsWith(inputValue)) {
    //     return -1;
    //   }
    //   if (labelB.startsWith(inputValue)) {
    //     return 1;
    //   }
    //   return labelA.localeCompare(labelB);
    // };
    // const onInputChange = (value: string, meta: InputActionMeta): void => {
    //   if (meta.action === 'input-change') {
    //     const filteredOptions = (documentOptions as any).sort((a: any, b: any) => customSort(a, b, value));
    //     setDocumentOptionsLocal(filteredOptions);
    //   } else if (meta.action === 'menu-close') {
    //     setDocumentOptionsLocal(documentOptions);
    //   }
    // };
    var handleFileUploadFromLocal = function (event) {
        var _a;
        var files = event.target.files;
        if (!files)
            return;
        var file = files[0];
        if ((file === null || file === void 0 ? void 0 : file.size) > maxFileSizeAllowedInMB * 1000000) {
            onFileSizeUploadWarning("File size cannot exceed ".concat(maxFileSizeAllowedInMB, "mb"));
            event.target.value = '';
            return;
        }
        if (!(fileName === null || fileName === void 0 ? void 0 : fileName.value)) {
            onFileNameRequiredWarning('Document Type is Required');
            event.target.value = '';
            return;
        }
        // this makes api call to upload select file data to server
        handleUpload(file, (_a = fileName === null || fileName === void 0 ? void 0 : fileName.value) === null || _a === void 0 ? void 0 : _a.toString(), function (success) {
            if (success === void 0) { success = false; }
            success && setFileName(null);
            event.target.value = '';
        });
    };
    return (React.createElement("div", { className: containerClassName },
        React.createElement("input", { type: 'file', ref: fileUploadRef, className: "lfc-hidden", onChange: handleFileUploadFromLocal, accept: ACCEPTABLE_FILE_UPLOAD_TYPES }),
        React.createElement(Dropdown, __assign({ options: documentOptionsLocal, value: fileName, onChange: function (_event, option) {
                setFileName(option);
            }, size: "small", className: "lfc-w-[150px]", textInputProps: { placeholder: 'Select document type' }, sx: {
                '& .MuiOutlinedInput-root': {
                    backgroundColor: 'white'
                }
            } }, dropdownProps)),
        isUploading ? (React.createElement(LoadingButton, null)) : (React.createElement(Button, { variant: uploadButtonVariant || 'secondary', startIcon: React.createElement(FileUploadOutlined, null), onClick: function () {
                var _a;
                (_a = fileUploadRef === null || fileUploadRef === void 0 ? void 0 : fileUploadRef.current) === null || _a === void 0 ? void 0 : _a.click();
            } }, uploadButtonText))));
};
export default CustomDocumentUpload;
//# sourceMappingURL=CustomDocumentUpload.js.map